export const getPublicUrl = () => {
  const appType = process.env.NEXT_PUBLIC_APP_TYPE;
  switch (appType) {
    case 'production':
      return 'https://mylofamily.com';
    case 'staging1':
      return 'https://test.mylofamily.com';
    case 'staging2':
      return 'https://staging.mylofamily.com';
    case 'dev':
      return 'https://dev.mylofamily.com';
    default:
      return 'http://localhost:3000';
  }
};

export const getApiEndpoint = () => {
  const appType = process.env.NEXT_PUBLIC_APP_TYPE;
  switch (appType) {
    case 'production':
      return 'https://api.myloapp.in/';
    case 'staging1':
      return 'https://test-api.myloapp.in/';
    case 'staging2':
      return 'https://staging-api.myloapp.in/';
    case 'dev':
      return 'https://dev-api.myloapp.in/';
  }
};
export const getRazorPayKey = () => {
  const env = process.env.NEXT_PUBLIC_APP_TYPE;

  switch (env) {
    case 'production':
      return 'rzp_live_PJbpypM6SVEHa5';
    case 'staging1':
      return 'rzp_test_O0enOsnohlpTMw';
    case 'staging2':
      return 'rzp_test_O0enOsnohlpTMw';
    case 'dev':
      return 'rzp_test_O0enOsnohlpTMw';
    default:
      return 'rzp_test_O0enOsnohlpTMw';
  }
};
export const getGokwikMerchantId = () => {
  const env = process.env.NEXT_PUBLIC_APP_TYPE;

  switch (env) {
    case 'production':
      return '193cxny9qq3z';

    default:
      return '19bv6opy6ogz';
  }
};
export const getGokwikScript = () => {
  const env = process.env.NEXT_PUBLIC_APP_TYPE;

  switch (env) {
    case 'production':
      return 'https://pdp.gokwik.co/v4/build/gokwik.js';

    default:
      return 'https://sandbox.pdp.gokwik.co/v4/build/gokwik.js';
  }
};
export const getKwikpassScript = () => {
  const env = process.env.NEXT_PUBLIC_APP_TYPE;

  switch (env) {
    case 'production':
      return 'https://pdp.gokwik.co/kwikpass/plugin/build/kp-custom-merchant.js';

    default:
      return 'https://sandbox.pdp.gokwik.co/kwikpass/plugin/build/kp-custom-merchant.js';
  }
};
export const getKwickpassSecretKey = () => {
  const env = process.env.NEXT_PUBLIC_APP_TYPE;

  switch (env) {
    case 'production':
      return 'zH4NRP1HMALxxCFnRZABFA7GOJtzU_gIj02alfL1lvI';

    default:
      return 'zH4NRP1HMALxxCFnRZABFA7GOJtzU_gIj02alfL1lvI';
  }
};
export const getKwikpassEnvironment = () => {
  const env = process.env.NEXT_PUBLIC_APP_TYPE;

  switch (env) {
    case 'production':
      return 'production';

    default:
      return 'sandbox';
  }
};
export const getShipRocketScript = () => {
  const env = process.env.NEXT_PUBLIC_APP_TYPE;

  switch (env) {
    case 'production':
      return 'https://checkout-ui.shiprocket.com/assets/js/channels/shopify.js';

    default:
      return 'https://checkout-ui.shiprocket.com/assets/js/channels/shopify.js';
  }
};
export const getSeoVisibility = () => {
  const appType = process.env.NEXT_PUBLIC_APP_TYPE;
  const forceSEO = process.env.NEXT_PUBLIC_FORCE_SEO;

  if (forceSEO === 'true') {
    return true;
  }
  switch (appType) {
    case 'production':
      return true;
    default:
      return false;
  }
};

export const getEnvironmentVariables = () => {
  return process.env.NEXT_PUBLIC_APP_TYPE;
};

export const getDefaultBuildToken = () => {
  const apiEndPoint = getApiEndpoint();

  switch (apiEndPoint) {
    case 'https://api.myloapp.in/':
      return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJwbGF0Zm9ybSI6IndlYiIsImRldmljZV9pZCI6bnVsbCwiZW52aXJvbm1lbnQiOiJwcm9kIiwiaXNub3RGb3JTZXNzaW9uIjp0cnVlLCJpYXQiOjE2OTI4NTYyNjd9.4n9UzFFYdY_pOBCm_4Umwo_USbeXMa2tOY565fr-D5g';
    case 'https://test-api.myloapp.in/':
      return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJwbGF0Zm9ybSI6IndlYiIsImRldmljZV9pZCI6bnVsbCwiZW52aXJvbm1lbnQiOiJzMSIsImlzbm90Rm9yU2Vzc2lvbiI6dHJ1ZSwiaWF0IjoxNjkyODU2MDgyfQ.cOVnOR1YKkeqnxdwzW9H_0YGGAOI_T39N0zYO1T6Y2M';
    case 'https://staging-api.myloapp.in/':
      return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJwbGF0Zm9ybSI6IndlYiIsImRldmljZV9pZCI6bnVsbCwiZW52aXJvbm1lbnQiOiJzMiIsImlzbm90Rm9yU2Vzc2lvbiI6dHJ1ZSwiaWF0IjoxNjkyODU2MTY1fQ.qBRLA4VejIpFUH3uW1Bu_Jq_hsiuSuIeje8KfJ_y5jI';
    case 'https://dev-api.myloapp.in/':
      return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJwbGF0Zm9ybSI6IndlYiIsImRldmljZV9pZCI6bnVsbCwiZW52aXJvbm1lbnQiOiJkZXYiLCJpc25vdEZvclNlc3Npb24iOnRydWUsImlhdCI6MTY5Mjg1NTg0OH0.0PdERiAPwCm42t118UoOVuvEDGzEcdkp0ogZ39yX50s';
    default:
      return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJwbGF0Zm9ybSI6IndlYiIsImRldmljZV9pZCI6bnVsbCwiZW52aXJvbm1lbnQiOiJkZXYiLCJpc25vdEZvclNlc3Npb24iOnRydWUsImlhdCI6MTY5Mjg1NTg0OH0.0PdERiAPwCm42t118UoOVuvEDGzEcdkp0ogZ39yX50s';
  }
};

export const enableDataDogLogging = () => {
  const env = process.env.NEXT_PUBLIC_APP_TYPE;

  switch (env) {
    case 'production':
      return true;

    default:
      return false;
  }
};
